import { Button, TextInput } from "@mantine/core";
import { useEffect, useState } from "react";

import Card from "@/components/Card";
import { IconSearch } from "@tabler/icons-react";
import { orpcClient } from "@/lib/orpc-client";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

function EmployeeManagement() {
  const { t } = useTranslation();
  const [filteredData, setFilteredData] = useState([]);
  const [originalData, setOriginalDataData] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const navigate = useNavigate();

  const handleInputChange = (e) => {
    const value = e.target.value;
    setInputValue(value);

    const filtered = originalData.filter((item) =>
      item?.name?.toLowerCase().startsWith(value.trim().toLowerCase())
    );

    if (value === "") {
      setFilteredData(originalData);
    } else {
      setFilteredData(filtered);
    }
  };

  const handleClickEmployeeCard = (data) => {
    navigate(`/hrMainPage/employee/${data.id}`);
  };

  const handleAddEmployee = () => {
    navigate("/hrMainPage/addEmployee");
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await orpcClient.employee.list({});
        setOriginalDataData(result);
        setFilteredData(result);
      } catch (error) {
        console.error(t("employee.management.errorFetchingData"), error);
      }
    };

    fetchData();
  }, []);
  console.log("filteredData", filteredData);
  return !originalData || originalData?.length === 0 ? (
    <div className="flex min-h-screen h-full items-center justify-center">
      <div className="w-[487px] rounded-xl bg-white px-16 py-20">
        <div className="text-center" style={{ color: "#6F6F6F" }}>
          {t("employee.management.noEmployees")}
        </div>
        <div className="flex text-center">
          <Button
            variant="outline"
            color="gray"
            style={{ width: "100%", margin: "1rem" }}
            radius="md"
          >
            {t("employee.management.templateExcel")}
          </Button>
          <Button
            variant="outline"
            color="gray"
            style={{ width: "100%", margin: "1rem" }}
            radius="md"
            onClick={handleAddEmployee}
          >
            {t("employee.management.manualAdd")}
          </Button>
        </div>
      </div>
    </div>
  ) : (
    <>
      <div className="min-h-screen h-full items-center justify-center">
        <div
          className="flex items-center justify-between p-4"
          style={{ backgroundColor: "#ECECEC" }}
        >
          <div className="flex flex-1 justify-center">
            <TextInput
              leftSection={<IconSearch size={16} />}
              onChange={handleInputChange}
              placeholder={t("employee.management.searchPlaceholder")}
            />
          </div>
          <Button
            variant="default"
            style={{ minWidth: "3rem", margin: "1rem" }}
            radius="xl"
            onClick={() => handleAddEmployee()}
          >
            {t("employee.management.addEmployee")}
          </Button>
        </div>

        <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
          {filteredData?.map((data) => {
            return (
              <Card
                props={data}
                onClick={() => handleClickEmployeeCard(data)}
              />
            );
          })}
        </div>
      </div>
    </>
  );
}

export default EmployeeManagement;
